import React from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Typography from '@mui/material/Typography';
import {Divider } from '@mui/material';
import InfoItemBox from './InfoItemBox';
import { InfoItemBoxProps } from '../dataObjects/contentTypes';

const content: InfoItemBoxProps[] = [
  {
    title: 'Complete the Online Statement of Organization',
    blocks: [
      {
        type: 'list',
        listType: 'bullet',
        items: [
          {
            content: [
              {
                type: 'text',
                content: 'Click '
              },
              {
                type: 'link',
                text: 'here',
                url: 'https://www.ocpfreporter.us/onlineorganization/signup'
              },
              {
                type: 'text',
                content: ' to access OCPF Online Filer Organization System that candidates and political committees use to organize their committees with OCPF.'
              },
            ]
          },
          {
              content: [
                {
                  type: 'text',
                  content: 'Once the Statement of Organization is submitted via the OCPF Online Filer Organization System, an OCPF Auditor will be notified. If the Statement of Organization is approved, a CPF ID number will be issued, and the filer’s profile will appear on the '
                },
                {
                  type: 'link',
                  text: 'OCPF website',
                  url: '/Filers'
                },
                {
                  type: 'text',
                  content: '.'
                },
              ]
            }
        ] 
        },
        {
          type: 'paragraph',
          content: [
            {
              type: 'image',
              src: '/online_organization.jpg',
              alt: 'OCPF Online Filer Organization System',
              link: 'https://www.ocpfreporter.us/onlineorganization/signup'
            }
          ]
        },
        {
          type: 'list',
          listType: 'bullet',
          items: [
            {
              content: [
                {
                  type: 'text',
                  content: 'Help Video: '
                },
                {
                  type: 'link',
                  text: 'How to Organize Your Committee with OCPF',
                  url: '#'
                },
                
              ]
            },
            {
                content: [
                  {
                    type: 'text',
                    content:  'User Manual (PDF): '
                  },
                  {
                    type: 'link',
                    text: 'Online Filer Organization System User Guide',
                    url: 'https://ocpf.blob.core.windows.net/online-organization/ocpf_online_organization_user_manual_print.pdf'
                  },
                ]
              }
          ] 
      }
      

      ]
  },
  {
      title: 'Appoint a Chair and a Treasurer',
      blocks: [
        {
          type: 'paragraph',
          content: [
            {
              type: 'text',
              content: 'The office of treasurer is vital to an organized political committee. Under the campaign finance law, no money or anything of value can be received and no expenditures or disbursements can be made by a political committee (or any person acting under the authority of or on behalf of a political committee) while it has no treasurer.'
            }
          ]
        },
        {
          type: 'subheading',
          content: 'Treasurers:'
        },
        {
          type: 'list',
          listType: 'bullet',
          items: [
            {
              content: [
                {
                  type: 'text',
                  content: 'Remain subject to all the duties and responsibilities imposed by the campaign finance law until his or her written resignation of the office is received or his or her successor\'s written acceptance is filed with OCPF (or the city or town clerk);'
                }
              ]
            },
            {
              content: [
                {
                  type: 'text',
                  content: 'Authorize expenditures made on behalf of the political committee;'
                }
              ]
            },
            {
              content: [
                {
                  type: 'text',
                  content: 'Keep detailed accounts of the campaign finance activities of the political committee;'
                }
              ]
            },
            {
              content: [
                {
                  type: 'text',
                  content: 'Keep and preserve detailed records of the campaign finance activities of the political committee;'
                }
              ]
            },
            {
              content: [
                {
                  type: 'text',
                  content: 'Prepare and filing required campaign finance activity reports.'
                }
              ]
            }
          ]
        }
      ]
     },
     {
      title: 'Who Cannot Serve as the Treasurer of a Political Committee',
      blocks: [
        {
          type: 'paragraph',
          content: [
            {
              type: 'text',
              content: 'Care must be taken when selecting a new treasurer for the political committee. There are restrictions on who may serve as the treasurer for a political committee organized in Massachusetts. Those who '
            },
            {
              type: 'text',
              content: 'cannot',
              isBold: true
            },
            {
              type: 'text',
              content: ' serve as the treasurer of a political committee include:'
            }
          ]
        },
        {
          type: 'list',
          listType: 'bullet',
          items: [
            {
              content: [
                {
                  type: 'text',
                  content: 'A '
                },
                {
                  type: 'link',
                  text: 'public employee',
                  url: 'https://ocpf2.blob.core.windows.net/pdf/guides/fs_pub_emp.pdf'
                },
                {
                  type: 'text',
                  content: ' (one who is employed by the Commonwealth, a county or a city or town.);'
                }
              ]
            },
            {
              content: [
                {
                  type: 'text',
                  content: 'The Secretary of the Commonwealth;'
                }
              ]
            },
            {
              content: [
                {
                  type: 'text',
                  content: 'A city or town clerk (except those that do not administer elections);'
                }
              ]
            },
            {
              content: [
                {
                  type: 'text',
                  content: 'A member of a board of registrars of voters in any city or town;'
                }
              ]
            },
            {
              content: [
                {
                  type: 'text',
                  content: 'A member of an election commission in any city or town;'
                }
              ]
            },
            {
              content: [
                {
                  type: 'text',
                  content: 'A candidate may not be the treasurer of the political committee which has been organized on his behalf.'
                }
              ]
            }
          ]
        }
      ]
     },
     {
      title: "Additional Help & Information",
      blocks: [
        {
          type: "list",
          listType: "bullet",
          items: [
            {
              content: [
                {
                  type: "text",
                  content: "Campaign Finance Guide: "
                },
                {
                  type: "link",
                  text: "State Ballot Question Committees",
                  url: "https://ocpf2.blob.core.windows.net/pdf/guides/guidestatebq.pdf"
                },
                {
                  type: "text",
                  content: "."
                }
              ]
            },
            {
              content: [
                {
                  type: "text",
                  content: "Campaign Finance Guide: "
                },
                {
                  type: "link",
                  text: "Committee Treasurer",
                  url: "https://ocpf2.blob.core.windows.net/pdf/guides/treasurerguide.pdf"
                },
                {
                  type: "text",
                  content: " - Information about the role and duties of a political committee treasurer in Massachusetts."
                }
              ]
            },
            {
              content: [
                {
                  type: "link",
                  text: "Contribution Limits Chart",
                  url: "/Legal/ContributionLimits"
                },
                {
                  type: "text",
                  content: "."
                }
              ]
            },
            {
              content: [
                {
                  type: "text",
                  content: "Public Employees and Campaigns: A "
                },
                {
                  type: "link",
                  text: "Fact Sheet",
                  url: "https://ocpf2.blob.core.windows.net/pdf/guides/fs_pub_emp.pdf"
                },
                {
                  type: "text",
                  content: "."
                }
              ]
            },
            {
              content: [
                {
                  type: "text",
                  content: "OCPF Interpretive Bulletin "
                },
                {
                  type: "link",
                  text: "IB-90-02",
                  url: "https://ocpf2.blob.core.windows.net/pdf/legaldocs/IB-90-02.pdf"
                },
                {
                  type: "text",
                  content: ": Disclosure and Reporting of Contributions and/or Expenditures Relating to Ballot Questions."
                }
              ]
            },
            {
              content: [
                {
                  type: "text",
                  content: "OCPF Interpretive Bulletin "
                },
                {
                  type: "link",
                  text: "IB-10-01",
                  url: "https://ocpf2.blob.core.windows.net/pdf/legaldocs/IB-10-01.pdf"
                },
                {
                  type: "text",
                  content: ": Disclaimers on Communications Made to Influence or Affect the Vote on a Ballot Question."
                }
              ]
            },
            {
              content: [
                {
                  type: "text",
                  content: "Disclaimers and Disclosures for Advertisements and Communications Video Tutorial: "
                },
                {
                  type: "link",
                  text: "Click Here",
                  url: "#"
                }
              ]
            }
          ]
        }
      ]
    }
];

const RegisterInfoBallotQuestion = (): JSX.Element => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });


  return (
      <div>
        
        <Typography
              component="h1"
              variant="h4"
              align={'left'}
              data-aos={'fade-up'}
              gutterBottom
              sx={{
                fontWeight: 700,
              }}
              paddingTop={4}>
              Set Up Your Committee with OCPF
            </Typography>

            <Divider />
            
         {content.map((content, index) => (
          <InfoItemBox key={index} {...content} />
        ))}
      </div>
       
   
        
  );
};

export default RegisterInfoBallotQuestion;
